export const languageChannelName = 'language_channel';
export const themeChannelName = 'theme_channel';
export const accessibilityChannelName = 'accessibility_channel';
